// extracted by mini-css-extract-plugin
export var slideDownAndFade = "compatibleNotice-module--slideDownAndFade--3fac2";
export var slideLeftAndFade = "compatibleNotice-module--slideLeftAndFade--45588";
export var slideRightAndFade = "compatibleNotice-module--slideRightAndFade--7a683";
export var slideUpAndFade = "compatibleNotice-module--slideUpAndFade--c7344";
export var toolTipArrow = "compatibleNotice-module--tool-tip-arrow--de6b1";
export var toolTipContent = "compatibleNotice-module--tool-tip-content--bb3a4";